export const  stories_EN = ['How the wild cat got his eyes', "The inner voice", "Heaven and hell", "Standing up on the inside", "The Cracked pot",
    "School of the animals", "Peace of mind", "The final lesson", "I wish you enough", "The broken mirror"];

export const stories_FA = ["چگونه گربه وحشی چشمانش را پیدا کرد", "صدای درون", "بهشت و جهنم", "کنار ایستادن", "گلدان شکسته",
    "مدرسه حیوانات", "آرامش ذهن", "درس آخر", "تو را همیشه آرزو کرده ام", "آیینه شکسته"];

export const stories_SE = ["Hur den vilda katten fick ögonen", "Den inre rösten", "Himlen och helvetet", "Stå upp på insidan", "Den spruckna krukan",
    "Djurens skola", "Sinnesro", "Den sista lektionen", "Jag önskar dig tillräckligt", "Den krossade spegeln"];

export const stories_SO = ["Side bay bisada duurjoogta ahi uga helaysaa  indhaheeda", "Codkii hoose", "JANO IYO CADAABTII", "Gudaha istaag", "Dherigii dilaacay",
"Iskuulka xayawaanka", "IN LAY S NABAD SIIYO", "Casharkii Ugu danbeeyay", "Waxaan rajaynayaa Inay nagu filan tahay", "MURAAYADII JABTAY"];

export const stories_ES = ["Cómo obtuvo el gato silvestre sus ojos", "La voz interna", "El cielo y el infierno", "De pie en el interior", "La vasija agrietada",
"Escuela de animales", "Paz interior", "La lección final", "Te deseo lo suficiente", "El espejo roto"];

export const stories_JP = ["どのように野生の猫は彼の目を得ました", "内なる声", "天と地獄", "内側に立っ", "ひびの入った鍋",
"動物の学校", "心の平和", "最後のレッスン", "私は十分にあなたを願っています", "壊れたミラー"];

export const stories_DE = ["die Wildkatze seine Augen bekam", "Die innere Stimme", "Himmel und Hölle", "Ich stehe auf der Innenseite", "Der Cracked Pot",
"Schule der Tiere", "Seelenfrieden", "Die letzte Lektion", "Ich wünsche dir genug", "Der zerbrochene Spiegel"];

export const stories_FR = ["Comment le chat sauvage a eu ses yeux", "La voix intérieure", "Paradis et enfer", "Debout à l'intérieur", "Le pot craquelé",
"École des animaux", "Tranquillité d'esprit", "La leçon finale", "Je vous souhaite assez", "Le miroir brisé"];

export const stories_CN = ["这只大猫是如何得到他的眼睛的", "内心的声音", "天堂与地狱", "是内心的力量让人强大起来", "有裂缝的罐子",
"动物学校", "心灵的安宁", "最后一课", "我愿你拥有足够的", "破碎的镜子"];

export const stories_UAE = ["كيف حصلت القطة البرية على عينيها", "الصوت الداخلى", "النعيم و الجحيم", "الوقوف من الداخل", "الإناء المتصدع",
"مدرسة الحيوانات", "راحة البال", "الدرس الأخير", "أتمنى لك ما يكفى", "المرآة المكسورة"];

export const stories_IN = ["जंगली बिल्ली ने अपनी आंखे कैसे पायीं।", "अन्तर्मन की आवाज़", "स्वर्ग और नर्क", "अंदर से मजबूत होना", "टूटा हुआ बर्तन",
"जानवरों का विद्यालय", "मन की शांति", "अंतिम सीख", "मैं तुम्हारे लिए प्रार्थना करता रहूँगा", "टूटा हुआ आईना"];

export const stories_RU = ["Как Дикий Кот получил свои глаза", "Внутренний голос", "Рай и ад", "Опирайся на стержень внутри себя", "Треснувший горшок",
"Школа животных", "Спокойствие в душе", "Последний урок", "Я желаю тебе достаточно всего", "Разбитое зеркало"];

export const stories_AF = ["څنګه وحشیانه پيشو سترګې ترلاسه کړې", "داخلي غږ", "جنت او دوزخ", "دننه باندې پاڅه اودرېدل", "چټک برتن",
"د څارویو ښوونځی", "ذهن سکون", "وروستۍ لوست", "تاسو پوره غوښتل زما خواهش دې", "مات شوی عکس"];

export const stories_TI = ["እቲ ናይ በረኻ ድሙ ከመይ አዒንቱ ከምዝረኸበ ።", "ውሽጣዊ ድምፂ", "ገነትን ሲኦልን", "ኣብ ውሽጢ ጠጠው ምባል", "እቲ ዝነቕዐ ዕትሮ",
"ቤት ትምህርቲ እንስሳት", "ናይ ኣእምሮ ዕረፍቲ", "ናይ መወዳእታ  ትምህርቲ", "ክንዲ ዝአክል ይምነየልካ", "እቲ ስባር መስትያት"]



